module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "delivery-address"
  }, [(_vm.order.isAddressBtnAvailable && _vm.order.deliveryAddress) ? _c('div', {
    staticClass: "bloc-btn-modify"
  }, [_c('button', {
    staticClass: "btn btn-modify",
    on: {
      "click": function($event) {
        _vm.showModalDeliveryAddress(_vm.dataDeliveryAdress, 'editDeliveryAddress');
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("orders.btnOrders.btnModify")) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.order.isAddressBtnAvailable && !_vm.order.deliveryAddress) ? _c('div', {
    staticClass: "delivery-address-btn"
  }, [(_vm.clientHasRights) ? _c('button', {
    staticClass: "btn address-btn btn-client",
    on: {
      "click": function($event) {
        _vm.showModalDeliveryAddress(_vm.dataDeliveryAdress, 'addDeliveryAddress');
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("orders.deliveryAddress.addDeliveryAddress")) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.order.deliveryAddress) ? _c('div', {
    staticClass: "delivery-address-content"
  }, [_c('div', {
    staticClass: "address-content"
  }, [_c('p', {
    directives: [{
      name: "html-safe",
      rawName: "v-html-safe",
      value: (_vm.order.deliveryAddress.content),
      expression: "order.deliveryAddress.content"
    }]
  })])]) : _vm._e(), _vm._v(" "), _c('Modal', {
    attrs: {
      "action": _vm.dataAction,
      "id": "deliveryAddress"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62cb6740","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/order-common/delivery-address.vue
// module id = 3227
// module chunks = 0